import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('text-box',{attrs:{"label":_vm.title,"icon":_vm.icon}},[_c(VContainer,{attrs:{"fluid":""}},[_c(VRow,[_c(VCol,{attrs:{"cols":"12"}},[_c('v-chart',{staticStyle:{"height":"300px","width":"100%"},attrs:{"option":_vm.options,"init-options":{renderer: 'canvas'},"autoresize":""}})],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }